import Lynelle1 from './Lynelle.png'
import Lynelle2 from './Lynelle.png'





const Lynelleimages =[
Lynelle1,Lynelle2
]

export default Lynelleimages;